export default __webpack_public_path__ + "static/media/microsoft-logo.0374a3c1.svg";